import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/auth-store'
import { awaitAuthReady } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/dashboard/')({
  beforeLoad: async () => {
    await awaitAuthReady()
    const isSuperAdmin = useAuthStore.getState().isSuperAdmin()

    throw redirect({
      to: isSuperAdmin
        ? '/dashboard/overview'
        : '/dashboard/repeated-check-ins',
    })
  },
})
